import styles from "./HorizontalLeaderCardScroller.module.css";
import LeaderCard from "../../components/LeaderCard/LeaderCard";
import { useCallback, useEffect, useRef, useState } from "react";
import ArrowSubtitle from "../../components/ArrowSubtitle/ArrowSubtitle";
import useWindowSize from "../../hooks/useWindowSize";
import useScrollPosition from "../../hooks/useScrollPosition";
import { ourLeadership } from "../../data/people";
function HorizontalLeaderCardScroller() {
    const [focusedCard, setFocusedCard] = useState("0");
    const leadersContainerRef = useRef(null);
    const scrollContainerRef = useRef(null);
    const windowSize = useWindowSize();
    const scrollPosition = useScrollPosition();

    const overflowWrapperTopMargin = 100;
    const heroTopTopMargin = 160;
    const overflowWrapperBottomPadding = 140;
    const heroCardWidth = 360;

    const getCardHeight = useCallback(() => {
        return leadersContainerRef.current.getBoundingClientRect().height;
    }, []);

    const getStickyTop = useCallback(() => {
        const top =
            Math.max((windowSize.height - getCardHeight()) / 2, 0) - 100;
        // console.log(cardHeight);
        return top;
    }, [windowSize, getCardHeight]);

    const getTopOffset = useCallback(() => {
        return (
            heroTopTopMargin +
            document.getElementById(styles.hero_top).getBoundingClientRect()
                .height +
            Math.max(0, overflowWrapperTopMargin - getStickyTop())
        );
    }, [getStickyTop]);

    const setStickyTop = useCallback(() => {
        const top = getStickyTop();

        leadersContainerRef.current.parentNode.style.top = top + "px";
    }, [getStickyTop]);

    const getScrollContainerHeight = useCallback(() => {
        return (
            getFullLeadersWidth() +
            getTopOffset() +
            Math.max(
                0,
                overflowWrapperBottomPadding +
                    getCardHeight() -
                    windowSize.height
            )
        );
    }, [getTopOffset, getCardHeight, windowSize]);

    const setScrollContainerHeight = useCallback(() => {
        scrollContainerRef.current.style.setProperty(
            "--extra-scroll-height",
            `${getScrollContainerHeight()}px`
        );
    }, [getScrollContainerHeight]);

    function getFullLeadersWidth() {
        const width =
            (ourLeadership.length - 1) * heroCardWidth +
            (ourLeadership.length - 1) * 0;

        return width;
    }

    const findClosestToMiddle = useCallback(() => {
        const middleOfScreen = windowSize.width / 2;
        const children = leadersContainerRef.current.children;

        let closestElement = null;
        let smallestDistance = Infinity;

        for (const child of children) {
            const rect = child.getBoundingClientRect();
            const childCenter = rect.left + rect.width / 2;
            const distanceToMiddle = Math.abs(childCenter - middleOfScreen);

            // Stop searching if distances are increasing
            if (distanceToMiddle > smallestDistance) break;

            smallestDistance = distanceToMiddle;
            closestElement = child;
        }

        return closestElement;
    }, [windowSize]);

    const handleScroll = useCallback(() => {
        const leadersTranslationPosition = Math.min(
            Math.max(0, scrollPosition - getTopOffset()),
            getFullLeadersWidth()
        );
        leadersContainerRef.current.style.setProperty(
            "--translation",
            `${leadersTranslationPosition}px`
        );

        // const videoTop = Math.min(
        //     0,
        //     getScrollContainerHeight() - scrollPosition
        // );

        // heroBackgroundRef.current.style.setProperty("--top", videoTop + "px");

        setFocusedCard(findClosestToMiddle().dataset.index);
    }, [findClosestToMiddle, getTopOffset, scrollPosition]);

    useEffect(() => {
        setFocusedCard(findClosestToMiddle().dataset.index);
    }, [findClosestToMiddle]);

    useEffect(() => {
        setScrollContainerHeight();
        setStickyTop();
    }, [setScrollContainerHeight, setStickyTop]);

    useEffect(() => {
        handleScroll();
    }, [handleScroll, scrollPosition]);

    // Allow horizontal scrolling (doesn't work for mobile)

    // function normalizeWheel(event) {
    //     let pixelX = event.deltaX;
    //     let pixelY = event.deltaY;

    //     if (event.deltaMode === WheelEvent.DOM_DELTA_LINE) {
    //         const lineHeight = 16; // guess, or measure from document
    //         pixelX *= lineHeight;
    //         pixelY *= lineHeight;
    //     } else if (event.deltaMode === WheelEvent.DOM_DELTA_PAGE) {
    //         const pageHeight = window.innerHeight;
    //         pixelX *= pageHeight;
    //         pixelY *= pageHeight;
    //     }

    //     return { pixelX, pixelY };
    // }

    // useEffect(() => {
    //     scrollContainerRef.current.addEventListener("wheel", (e) => {
    //         const { pixelX } = normalizeWheel(e);
    //         window.scrollBy(0, pixelX);
    //     });
    // }, []);

    return (
        <div ref={scrollContainerRef} id={styles.scroll_container}>
            {/* <div id={styles.hero}> */}
            <div id={styles.hero_top}>
                <div id={styles.hero_text}>
                    <ArrowSubtitle text={"Meet the leadership team"} />
                    <h1 className="main-h1">
                        Keel Digital Solutions' leadership team has{" "}
                        <em>diverse expertise</em> across a variety of
                        industries
                    </h1>
                    <p>
                        Including technology, banking, professional sports and
                        health care.
                    </p>
                </div>
            </div>
            <div id={styles.leaders_overflow_wrapper}>
                <div ref={leadersContainerRef} id={styles.leaders_container}>
                    {ourLeadership.map((l, index) => (
                        <LeaderCard
                            key={l.name}
                            index={`${index}`}
                            focusedCard={focusedCard}
                            setFocusedCard={setFocusedCard}
                            findClosestToMiddle={findClosestToMiddle}
                            {...l}
                        />
                    ))}
                </div>
            </div>
            {/* </div> */}
        </div>
    );
}

export default HorizontalLeaderCardScroller;
